export const DEFAULT_CELL_WIDTH = 500
export const DEFAULT_CELL_HEIGHT = 500

function DEFAULT_PROPS() {
  return {
    cellWidth: DEFAULT_CELL_WIDTH,
    cellHeight: DEFAULT_CELL_HEIGHT,
    table: [],
    idMap: {},
    lastRect: null
  }
}

const PUBLIC = {
  add(id, rect, sort = 0) {
    const { table, idMap, cellWidth, cellHeight } = this.props
    const startCol = Math.floor(rect.left / cellWidth)
    const startRow = Math.floor(rect.top / cellHeight)
    const endCol = Math.floor(rect.right / cellWidth)
    const endRow = Math.floor(rect.bottom / cellHeight)
    for (let row = startRow; row <= endRow; row++) {
      if (null == table[row]) {
        table[row] = []
      }
      for (let col = startCol; col <= endCol; col++) {
        if (null == table[row][col]) {
          table[row][col] = []
        }
        table[row][col].push({
          id,
          rect,
          sort
        })
      }
    }
    idMap[id] = {
      rect,
      sort,
      startCol,
      startRow,
      endCol,
      endRow
    }
    return this.PUBLIC
  },
  bake({ startRow = 0, endRow = Number.POSITIVE_INFINITY, startCol = 0, endCol = Number.POSITIVE_INFINITY } = {}) {
    const { table } = this.props
    const realEndRow = Math.min(table.length - 1, endRow)
    for (let r = startRow; r <= realEndRow; r++) {
      const row = table[r]
      if (null != row) {
        const realEndCol = Math.min(row.length - 1, endCol)
        for (let c = startCol; c <= realEndCol; c++) {
          const cell = row[c]
          if (null != cell) {
            row[c] = cell.sort(function (a, b) {
              return b.sort - a.sort
            })
          }
        }
      }
    }
    return this.PUBLIC
  },
  clear() {
    this.props.table = []
    this.props.idMap = {}
    this.props.lastRect = null
    return this.PUBLIC
  },
  update(id, rect, sort) {
    const { table, idMap } = this.props
    const prevRecord = idMap[id]
    // remove old record
    if (null != prevRecord) {
      const { startRow, endRow, startCol, endCol, rect: prevRect } = prevRecord
      if (
        null != rect &&
        rect.left === prevRect.left &&
        rect.right === prevRect.right &&
        rect.top === prevRect.top &&
        rect.bottom === prevRect.bottom
      ) {
        // no update needed
        return this.PUBLIC
      }
      for (let row = startRow; row <= endRow; row++) {
        if (null == table[row]) {
          continue
        }
        for (let col = startCol; col <= endCol; col++) {
          if (null == table[row][col]) {
            continue
          }
          table[row][col] = table[row][col].filter(record => record.id !== id)
        }
      }
    }
    if (null != rect) {
      // add new record
      this.PUBLIC.add(id, rect, null == sort ? (null == prevRecord ? void 0 : prevRecord.sort) : sort)
      // bake affected range
      const { startRow, endRow, startCol, endCol } = idMap[id]
      this.PUBLIC.bake({ startRow, endRow, startCol, endCol })
    }
    // return api
    return this.PUBLIC
  },
  isEmpty() {
    return 0 == this.props.table.length
  },
  test(x, y) {
    const { lastRect, cellWidth, cellHeight, table } = this.props
    if (
      null != lastRect &&
      lastRect.rect.left <= x &&
      lastRect.rect.right >= x &&
      lastRect.rect.top <= y &&
      lastRect.rect.bottom >= y
    ) {
      return lastRect.id
    } else {
      const cellCol = Math.floor(x / cellWidth)
      const cellRow = Math.floor(y / cellHeight)
      const rects = null == table[cellRow] ? null : table[cellRow][cellCol]
      if (null == rects) {
        return null
      } else {
        for (const testRect of rects) {
          if (
            testRect.rect.left <= x &&
            testRect.rect.right >= x &&
            testRect.rect.top <= y &&
            testRect.rect.bottom >= y
          ) {
            this.props.lastRect = testRect
            return testRect.id
          }
        }
      }
    }
    return null
  }
}

export default function RectHitTest({ cellWidth = DEFAULT_CELL_WIDTH, cellHeight = DEFAULT_CELL_HEIGHT } = {}) {
  const RectHitTest = {
    props: Object.assign({}, DEFAULT_PROPS(), { cellWidth, cellHeight })
  }
  RectHitTest.PUBLIC = {
    add: PUBLIC.add.bind(RectHitTest),
    bake: PUBLIC.bake.bind(RectHitTest),
    isEmpty: PUBLIC.isEmpty.bind(RectHitTest),
    clear: PUBLIC.clear.bind(RectHitTest),
    update: PUBLIC.update.bind(RectHitTest),
    test: PUBLIC.test.bind(RectHitTest)
  }
  return RectHitTest.PUBLIC
}
